import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Typography from 'components/Typography'
import useViewport from 'hooks/useViewport'

import classes from './SectionTitle.module.scss'

const getItemsClass = columns => {
  if (columns >= 2) {
    if (columns === 2) {
      return classes.itemsCol2
    }
    return classes.itemsColOver2
  }
}

/** @type {import("./types").default} */
const CompareSectionTitle = ({
  className,
  columns = 0,
  icon,
  label = '',
  labelVariant = 'heading-md',
  tagline,
  ...props
}) => {
  const { up } = useViewport()
  const hasMoreThanOneColumn = columns > 1

  return (
    <div className={clsx('SectionTitle', classes.container, className)} {...props}>
      <div className={clsx(classes.itemsBase, getItemsClass(columns))}>
        <div className={classes.rowWrapper}>
          {up('md') && (
            <div className={classes.iconWrapper}>
              <div className={classes.iconContainer} data-testid="SectionTitle-icon">
                <Icon icon={['far', icon]} className={classes.icon} size="24" />
              </div>
            </div>
          )}

          <Typography
            variant={labelVariant}
            component="h2"
            className={clsx(classes.title, { [classes.titleLeftAligned]: !hasMoreThanOneColumn })}
          >
            {label}
          </Typography>
        </div>
        {tagline && (
          <Typography variant="tight-sm" className={classes.tagline}>
            {tagline}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default CompareSectionTitle
